// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","title":"Footer_title__Q8g5X","socialMedia":"Footer_socialMedia__WdgPZ","items":"Footer_items__u3TyI","p":"Footer_p__iHp7l"};